import React from 'react';
import './index.scss';
import MixBlock1 from '../../atoms/mixBlock1/index';
import MixBlock2 from '../../atoms/mixBlock2/index';
import MixBlock3 from '../../atoms/mixBlock3/index';

interface ItemConfig {
  imgSrc?: string;
  title1?: string;
  title2?: string;
  enterText?: string;
  bgColor?: string;
  baseLink?: string;
  deepLink?: string;
  color?: string;
}
interface MixItem {
  rowNum: number;
  rowType: string;
  item1?: ItemConfig;
  item2?: ItemConfig;
  item3?: ItemConfig;
}
interface ImixedProps {
  id: string;
  pid?: string;
  children?: any[];
  config: MixItem;
  clickTo?: () => void;
}
const RowBlock1 = (item, clickTo, id) => {
  return (
    <MixBlock1 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item1 || {}}></MixBlock1>
  );
};
const RowBlock2 = (item, clickTo, id) => {
  return <>
    <MixBlock2 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item1 || {}}></MixBlock2>
    <MixBlock2 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item2 || {}}></MixBlock2>
  </>
}
const RowBlock3 = (item, clickTo, id) => {
  return <>
    <MixBlock3 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item1 || {}}></MixBlock3>
    <MixBlock3 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item2 || {}}></MixBlock3>
    <MixBlock3 id={id} clickTo={clickTo} rowType={item.rowType} config={item.item3 || {}}></MixBlock3>
  </>
}
class MixedBlocks extends React.Component<ImixedProps> {
  render() {
    const { config, clickTo, id, pid } = this.props
    return (
      <div className="mixedBlocksContent">
        <div className="mixBox">
          {
            config.rowNum === 3 ? RowBlock3(config, clickTo, id) :
              config.rowNum === 2 ? RowBlock2(config, clickTo, id) : RowBlock1(config, clickTo, id)
          }
        </div>
      </div>
    );
  }
};

export default MixedBlocks;